import orderBy from 'lodash/orderBy';

export const blogPosts = ({ items }) => orderBy(items, ['id'], ['desc'])
